import { Vue } from 'vue-class-component';
import { Inject } from 'vue-property-decorator';
import { VehicleInfo } from '@/components/vehicle-info';
import { WriteupModuleContext } from '@/store/writeup';

export class VehicleInfoContainer extends Vue {
	@Inject() readonly writeupModule!: WriteupModuleContext;

	get writeup() { return this.writeupModule.getters.writeupObject; }

	get isWriteupUpdating() { return this.writeupModule.getters.isWriteupUpdating; }

	get images() {
		if (this.writeup?.vehicle?.images && this.writeup.vehicle.images.length > 0) {
			return this.writeup.vehicle.images.map(img => ({
				image: img,
			}));
		}
		return [];
	}

	render() {
		return (
			<VehicleInfo
				vehicle={ this.writeupModule.getters.vehicleObject }
				loading={ this.isWriteupUpdating && !this.writeup }
				images={ this.images }
				vin={ this.writeupModule.getters.vehicleVin }
			/>
		);
	}
}
